// in zone-flag.ts
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = [
    'scroll',
    'mouseup',
    'mouseleave',
    'mousemove',
    'mouseover',
    'mouseout',
    'mousewheel',
    'pointermove',
    'pointerdown',
    'pointerup',
    'dragover',
    'pick',
];
